export const senatorEntityConfig = {
    entityType: 'Senators',
    entityFormattedTitle: 'Senators',
    entityCataloguePath: '/senate/members',
    entityCatalogueConfig: {
        constants: {},
    },
    entityDashboardConfig: {
        constants: {},
        isSavePDFEnabled: false,
    },
};
